var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4761 11.6657C7.4761 12.6436 8.26887 13.4364 9.2468 13.4364C10.2247 13.4364 11.0175 12.6436 11.0175 11.6657C11.0175 10.6878 10.2247 9.89499 9.2468 9.89499C8.26887 9.89499 7.4761 10.6878 7.4761 11.6657ZM7.4761 11.6657H4.50038C2.84358 11.6657 1.50046 10.3226 1.50038 8.66583L1.5 1M7.1441 4.5829H1.5M11.0175 4.5829C11.0175 5.56083 10.2247 6.35359 9.2468 6.35359C8.26887 6.35359 7.4761 5.56083 7.4761 4.5829C7.4761 3.60497 8.26887 2.8122 9.2468 2.8122C10.2247 2.8122 11.0175 3.60497 11.0175 4.5829Z",
    stroke: "#616874",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAudience);
export default __webpack_public_path__ + "static/media/CalendarAudience.84a5d687c33a8ecdf7f17a9ab3f9aefc.svg";
export { ForwardRef as ReactComponent };